import {Box, Modal, Text} from '@mantine/core';
import type {FC} from 'react';
import type {InterviewType} from '../../../../../core/entities/companyDetail/schema';
import {useMediaQuery} from '../../../../../shared/services/useMediaQuery';

type Props = {
  opened: boolean;
  onClose: () => void;
  interview: InterviewType;
  onPressNextPage: () => void;
  hasNextPage: boolean;
};

export const InterviewModal: FC<Props> = ({
  opened,
  onClose,
  interview,
  onPressNextPage,
  hasNextPage,
}) => {
  const {isPC} = useMediaQuery();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title=""
      withCloseButton={false}
      size="lg"
      padding="xl"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Box className="pc:flex pc:w-[534px]">
        <img
          src={interview.headshotURL}
          alt={`${interview.intervieweeName}の社員インタビュー`}
          className="w-full pc:w-[240px] pc:h-[240px]"
        />
        <Box className="pc:ml-16 mt-16 pc:mt-0">
          <p className="text-base text-black-2">
            {interview.yearsOfEmployment}
          </p>
          <p className="text-md font-bold mt-4">{interview.intervieweeName}</p>
          <p className="text-base text-black-2 mt-4">{interview.department}</p>
          <p className="text-base text-black-2 mt-4">
            {interview.interviewProfile}
          </p>
        </Box>
      </Box>
      {interview.interviewQA.map((qa) => (
        <Box className="mt-16" key={qa.question}>
          <Text className="font-bold">{qa.question}</Text>
          <Text className="mt-16">{convertQA(qa.answer)}</Text>
          {qa.answerPhotoURL && (
            <img
              src={qa.answerPhotoURL}
              alt="answerPhoto"
              className="w-full mt-16"
            />
          )}
        </Box>
      ))}
      <Box className="flex flex-col pc:flex-row items-center justify-center pc:gap-16 gap-8 my-12">
        {isPC ? (
          <>
            <button
              className="w-[120px] px-16 py-12 rounded-full bg-white flex items-center justify-center border-[2px] border-primary"
              onClick={() => {
                onClose();
              }}
            >
              <Text className="text-primary text-md font-bold">閉じる</Text>
            </button>
            {hasNextPage && (
              <button
                className="w-[214px] my-12 px-16 py-12 rounded-full bg-primary flex items-center justify-center border-[2px] border-primary"
                onClick={() => {
                  onPressNextPage();
                }}
              >
                <Text className="text-white text-md font-bold">
                  次のインタビューを読む
                </Text>
              </button>
            )}
          </>
        ) : (
          <>
            {hasNextPage && (
              <button
                className="w-[214px] my-12 px-16 py-12 rounded-full bg-primary flex items-center justify-center border-[2px] border-primary"
                onClick={() => {
                  onPressNextPage();
                }}
              >
                <Text className="text-white text-md font-bold">
                  次のインタビューを読む
                </Text>
              </button>
            )}
            <button
              className="w-[120px] px-16 py-12 rounded-full bg-white flex items-center justify-center border-[2px] border-primary"
              onClick={() => {
                onClose();
              }}
            >
              <Text className="text-primary text-md font-bold">閉じる</Text>
            </button>
          </>
        )}
      </Box>
    </Modal>
  );
};

const convertQA = (answer: string) => {
  const formattedText = answer.replaceAll('\n', '<br />');
  return <div dangerouslySetInnerHTML={{__html: formattedText}} />;
};
